import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  type: "button",
  class: "btn-link bg-transparent dropdown-toggle-split ps-0 pe-2",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  ref: "dropdown-button"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-three-dots-vertical",
  style: {"display":"flex","align-items":"center","justify-content":"center","height":"100%"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "dropdown-menu" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-palette me-3" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear me-3" }, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2 me-3" }, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dash me-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["btn-group rounded px-0 py-0", 
			_ctx.selected === true
				? 'text-white order-first'
				: 'btn-secondary text-dark order-last'
		]),
    style: _normalizeStyle(
			_ctx.selected === true
				? 'background-color:' + _ctx.competitor.name.keyword.color
				: ''
		),
    onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mousein = true)),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mousein = false))
  }, [
    _createElementVNode("button", {
      class: "btn-link bg-transparent font-semibold text-sm ps-8 pe-2 py-3 text-nowrap",
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => {
				_ctx.$emit('toggle');
				_ctx.mousein = !_ctx.mousein;
			})
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.selected === true ? 'text-white' : 'text-dark')
      }, _toDisplayString(_ctx.competitor.name.keyword.name), 3)
    ]),
    _createElementVNode("button", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["rounded-circle", [
					_ctx.mousein === true ? 'visible' : 'invisible',
					_ctx.selected === true ? 'text-white' : 'text-dark',
				]]),
        style: {"display":"block","background-color":"rgba(0, 0, 0, 0.1)","width":"1.25rem","height":"1.25rem"}
      }, _hoisted_3, 2)
    ], 512),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        class: "dropdown-item",
        to: {
					name: _ctx.$config('RouteConfig', 'BrandUpdateRouteName'),
					params: {
						organization_id: _ctx.$route.params.organization_id,
						space_id: _ctx.$route.params.space_id,
						brand_id: _ctx.competitor._id,
					},
				}
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(_toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'ChangeBrandColor'))), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        class: "dropdown-item",
        to: {
					name: _ctx.$config('RouteConfig', 'BrandUpdateRouteName'),
					params: {
						organization_id: _ctx.$route.params.organization_id,
						space_id: _ctx.$route.params.space_id,
						brand_id: _ctx.competitor._id,
					},
				}
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createTextVNode(_toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'BrandParameters'))), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("a", {
        class: "dropdown-item",
        href: "#",
        onClick: _cache[1] || (_cache[1] = ($event: any) => {
					_ctx.$emit('toggle');
					_ctx.mousein = !_ctx.mousein;
				})
      }, [
        (_ctx.selected === false)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(_toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'Show'))), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _hoisted_10,
              _createTextVNode(_toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'Hide'))), 1)
            ]))
      ])
    ])
  ], 38))
}